import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../redux';
import XAxisGrid from './CustomComponents/X-AxisGrid';
import YAxisGrid from './CustomComponents/Y-AxisGrid';
import { enableGrid, updateAxisOptions } from '../../../redux/ChartPoperties/ChartControlsActions';
import { Divider } from '@mui/material';

// Chart types that support multi-series
const MULTI_SERIES_CHART_TYPES = ['line', 'area', 'multibar', 'horizontalBar'];
const Grid = ({ iconColor }: { iconColor?: string }) => {
  const { chartControls, tabTileProps, chartType } = useSelector((state: RootState) => ({
    chartControls: state.chartControls,
    tabTileProps: state.tabTileProps,
    chartType:
      state.chartProperties.properties[
        `${state.tabTileProps.selectedTabId}.${state.tabTileProps.selectedTileId}`
      ]?.chartType,
  }));
  const dispatch = useDispatch();

  const propKey: string = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;
  const property = chartControls.properties[propKey].axisOptions;

  const handleEnableGrids = (key: string, option: string, value: any) => {
    dispatch(enableGrid(key, option, value));
  };

  const handleUpdateAxisOptions = (
    axis: string,
    option: string,
    value: any,
    series: string = '1',
  ) => {
    dispatch(updateAxisOptions(propKey, axis, option, value, series));
  };

  const isMultiSeriesChart = MULTI_SERIES_CHART_TYPES.includes(chartType);

  // Determine which axis is the measure axis based on chart type
  const isMeasureOnXAxis = ['horizontalBar', 'horizontalStacked'].includes(chartType);
  const measureAxisOptions = isMeasureOnXAxis ? property.xAxis : property.yAxis;
  const hasMultipleSeries =
    isMultiSeriesChart && Object.keys(measureAxisOptions || {}).length > 1 ? true : false;

  return (
    <div className="optionsInfo">
      <div style={{ marginTop: '-10px' }}>
        <XAxisGrid
          propKey={propKey}
          property={property}
          axisProps={property.xAxis['1']}
          enableGrids={handleEnableGrids}
          updateAxisOptions={handleUpdateAxisOptions}
          isMultiSeries={isMeasureOnXAxis && hasMultipleSeries}
          iconColor={iconColor}
        />
        <Divider
          sx={{
            height: '1px',
            backgroundColor: 'rgba(224, 224, 224, 1)',
            border: 'none',
            marginLeft: '0.45rem',
          }}
        />
        <YAxisGrid
          propKey={propKey}
          property={property}
          axisProps={property.yAxis['1']}
          enableGrids={handleEnableGrids}
          updateAxisOptions={handleUpdateAxisOptions}
          isMultiSeries={!isMeasureOnXAxis && hasMultipleSeries}
          iconColor={iconColor}
        />
      </div>
    </div>
  );
};

export default Grid;
